<template>
	<p>Files</p>
</template>

<script>
export default {};
</script>

<style></style>
